import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getLeaveTypeDetails,
  deleteLeaveType,
  clearError,
  clearSuccess,
} from "../../../../redux/Slices/authSlice";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";

const VacationDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const { leaveTypeDetails, isLoading, error, success } = useSelector(
    state => state.auth,
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const textAlign = isRTL ? "right" : "left";
  const dir = isRTL ? "rtl" : "ltr";
  const lastErrorRef = useRef({ message: null, time: 0 });

  useEffect(() => {
    if (id) {
      dispatch(getLeaveTypeDetails(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (success) {
      toast.success(success, { rtl: isRTL });
      dispatch(clearSuccess());
      setTimeout(() => {
        navigate("/vacations");
      }, 1000);
    }
    if (error) {
      const now = Date.now();
      const last = lastErrorRef.current;
      if (!last.message || last.message !== error || now - last.time > 2000) {
        toast.error(error, { rtl: isRTL });
        lastErrorRef.current = { message: error, time: now };
      }
      setTimeout(() => dispatch(clearError()), 3000);
    }
  }, [success, error, navigate, dispatch, isRTL]);

  const handleEdit = () => {
    navigate(`/vacations/edit/${id}`);
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteLeaveType(id));
    setShowDeleteModal(false);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
          color: "white",
        }}
      >
        <div>{t("vacations.details.loading")}</div>
      </div>
    );
  }

  if (!leaveTypeDetails) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
          color: "white",
        }}
      >
        <div>{t("vacations.details.noData")}</div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
      }}
    >
      <div style={{ marginBottom: "30px" }}>
        <button
          onClick={() => navigate("/vacations")}
          style={{
            backgroundColor: "#666",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            fontSize: "14px",
            flexDirection: isRTL ? "row" : "row-reverse",
          }}
        >
          <FaArrowLeft />
          {t("vacations.details.back")}
        </button>

        <h1
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "white",
            margin: 0,
            textAlign,
          }}
        >
          {t("vacations.details.title")}
        </h1>
      </div>

      <div
        style={{
          backgroundColor: "#1b3350",
          borderRadius: "12px",
          padding: "30px",
          border: "1px solid #333",
        }}
      >
        <div style={{ display: "flex", gap: "30px", flexWrap: "wrap" }}>
          <div style={{ flex: "1", minWidth: "300px" }}>
            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "14px",
                  textAlign,
                }}
              >
                {t("vacations.details.fields.nameAr")}
              </label>
              <div
                style={{
                  padding: "12px 15px",
                  backgroundColor: "#1a1f2e",
                  border: "1px solid #333",
                  borderRadius: "8px",
                  color: "white",
                  fontSize: "16px",
                  textAlign,
                  direction: dir,
                }}
              >
                {leaveTypeDetails.name_ar ||
                  leaveTypeDetails.name ||
                  t("vacations.details.notSpecified")}
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "14px",
                  textAlign,
                }}
              >
                {t("vacations.details.fields.nameEn")}
              </label>
              <div
                style={{
                  padding: "12px 15px",
                  backgroundColor: "#1a1f2e",
                  border: "1px solid #333",
                  borderRadius: "8px",
                  color: "white",
                  fontSize: "16px",
                  textAlign,
                  direction: dir,
                }}
              >
                {leaveTypeDetails.name_en ||
                  leaveTypeDetails.name ||
                  t("vacations.details.notSpecified")}
              </div>
            </div>
          </div>

          {/* العمود الأيمن */}
          <div style={{ flex: "1", minWidth: "300px" }}>
            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "14px",
                  textAlign,
                }}
              >
                {t("vacations.details.fields.defaultBalance")}
              </label>
              <div
                style={{
                  padding: "12px 15px",
                  backgroundColor: "#1a1f2e",
                  border: "1px solid #333",
                  borderRadius: "8px",
                  color: "white",
                  fontSize: "16px",
                  textAlign,
                  direction: dir,
                }}
              >
                {leaveTypeDetails.default_balance} {t("vacations.days")}
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "14px",
                  textAlign,
                }}
              >
                {t("vacations.details.fields.status")}
              </label>
              <div
                style={{
                  padding: "12px 15px",
                  backgroundColor: "#1a1f2e",
                  border: "1px solid #333",
                  borderRadius: "8px",
                  color: "white",
                  fontSize: "16px",
                  textAlign,
                }}
              >
                <span
                  style={{
                    backgroundColor: leaveTypeDetails.is_active
                      ? "#28a745"
                      : "#dc3545",
                    color: "white",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {leaveTypeDetails.is_active
                    ? t("vacations.status.active")
                    : t("vacations.status.inactive")}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            marginTop: "30px",
          }}
        >
          <button
            onClick={handleEdit}
            style={{
              backgroundColor: "#B3B3B3",
              color: "white",
              border: "none",
              padding: "12px 20px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexDirection: isRTL ? "row" : "row-reverse",
            }}
          >
            <FaEdit />
            {t("vacations.details.buttons.edit")}
          </button>

          <button
            onClick={handleDelete}
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              border: "none",
              padding: "12px 20px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexDirection: isRTL ? "row" : "row-reverse",
            }}
          >
            <FaTrash />
            {t("vacations.details.buttons.delete")}
          </button>
        </div>
      </div>

      {/* Modal حذف */}
      {showDeleteModal &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999999,
            }}
          >
            <div
              style={{
                backgroundColor: "#1b3350",
                padding: "30px",
                borderRadius: "12px",
                border: "1px solid #333",
                maxWidth: "400px",
                width: "90%",
                textAlign: "center",
                direction: dir,
              }}
            >
              <h3
                style={{
                  color: "white",
                  marginBottom: "20px",
                  fontSize: "18px",
                  textAlign,
                }}
              >
                {t("vacations.details.deleteModal.title")}
              </h3>
              <p
                style={{
                  color: "#ccc",
                  marginBottom: "30px",
                  fontSize: "14px",
                  textAlign,
                }}
              >
                {t("vacations.details.deleteModal.message", {
                  name: leaveTypeDetails.name_ar || leaveTypeDetails.name,
                })}
              </p>
              <p
                style={{
                  color: "white",
                  marginBottom: "30px",
                  fontSize: "12px",
                  textAlign,
                }}
              >
                {t("vacations.details.deleteModal.warning")}
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  flexDirection: isRTL ? "row" : "row-reverse",
                }}
              >
                <button
                  onClick={cancelDelete}
                  style={{
                    backgroundColor: "#666",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  {t("vacations.details.deleteModal.cancel")}
                </button>
                <button
                  onClick={confirmDelete}
                  style={{
                    backgroundColor: "#dc3545",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  {t("vacations.details.deleteModal.confirm")}
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};

export default VacationDetails;
